import React from 'react';
import Svg, { SvgProps, G, Path, Line, Rect } from 'react-native-svg';

export const SvgEat = ({ strokePath, ...props }: SvgProps) => (
  <Svg viewBox="0 0 256 256" width={'100%'} height={'100%'} {...props}>
    <G fill="none" fillRule="evenodd">
      <Rect fill="none" height="256" width="256" />
      <Line
        fill="none"
        stroke={strokePath}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="24"
        x1="84"
        x2="84"
        y1="32"
        y2="72"
      />
      <Line
        fill="none"
        stroke={strokePath}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="24"
        x1="84"
        x2="84"
        y1="116"
        y2="224"
      />
      <Path
        d="M120,32V80a36,36,0,0,1-72,0V32"
        fill="none"
        stroke={strokePath}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="24"
      />
      <Path
        d="M204,160H148S160,48,204,32V224"
        fill="none"
        stroke={strokePath}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="24"
      />
    </G>
  </Svg>
);
